/** Monotonic content-free counters. Input activity only resets a local idle
 * deadline; no key, pointer, text, position or interaction count is retained. */
export class EffortClock {
  private last: number;
  private activity: number;
  private allowed = true;
  private wasActive = true;
  active_ms = 0;
  wall_ms = 0;
  pause_count = 0;
  constructor(now: number) { this.last = now; this.activity = now; }
  sample(now: number) {
    now = Math.max(now, this.last);
    const elapsed = now - this.last;
    this.wall_ms += elapsed;
    if (this.allowed) this.active_ms += Math.max(0, Math.min(now, this.activity + 60000) - this.last);
    const active = this.allowed && now < this.activity + 60000;
    if (this.wasActive && !active) this.pause_count++;
    this.wasActive = active;
    this.last = now;
    const wall_ms = Math.floor(this.wall_ms), active_ms = Math.floor(this.active_ms);
    return { active_ms, wall_ms, paused_ms: wall_ms - active_ms, pause_count: this.pause_count };
  }
  setAllowed(allowed: boolean, now: number) { this.sample(now); this.allowed = allowed; this.sample(now); }
  touch(now: number) { this.sample(now); this.activity = now; this.sample(now); }
}
